import React, { useContext } from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import styles from './SectionWithColumns.module.scss';

const LabelsContext = React.createContext();

const SectionWithColumns = ({ headers, tiles }) => {
  return (
    <BaseSection { ...headers } anchor='success-stories'>
      <LabelsContext.Provider value={ headers.labels }>
        <div className={ styles.tiles }>
          { tiles && tiles.map(tile => <Tile key={ tile.title } { ...tile } />) }
        </div>
      </LabelsContext.Provider>
    </BaseSection>
  );
};

const Tile = ({ title, location, parameters, photo }) => {
  const photoProps = { photo, title, location };
  const infoProps = { title: location, parameters };

  return (
    <div className={ styles.Tile }>
      <Photo { ...photoProps } />
      <Info { ...infoProps } />
    </div>
  );
};
 
const Photo = ({ photo, title, location }) => {
  return (
    <div className={ styles.Photo }>
      <img className={ styles.photo } src={ photo } />
      <h6 className={ styles.title }>{ title }</h6>
      <p className={ styles.location }>{ location }</p>
    </div>
  );
};

const Info = ({ title, parameters }) => {
  const labels = useContext(LabelsContext);
  const labelsKeys = Object.keys(labels);

  return (
    <div className={ styles.Info }>
      <h2>{ title }</h2>
      { labelsKeys && labelsKeys.map(item => (
        <p key={ item } className={ styles.listItem }>
          <span className={ styles.label }>{ labels[item] }</span>
          <span className={ styles.value }> { parameters[item] }</span>
        </p>)
      ) }
    </div>
  );
};
 
export default SectionWithColumns;
